import React from 'react'
import './index.css'
const Loader = () => {
  return (
    <div id="preloader" className="preloader off">
        <div className="black_wall" />
        <div className="loader"></div>
    </div>
  )
}

export default Loader